const deleteAreasStr = {
  toastr: 'Deleted Documentation Type',
  toastr1: 'successfully deleted'
};

export default deleteAreasStr;
